import { CORNER_THICKNESS } from '@rta/rta-blueprint-library';

// import { CursorMode } from '../enums';
import { DesignerOptionsData } from '../types/designer-options-data.type';
// import { ShowDimensions } from '../../types';

/**
 * Detect if running in development mode (localhost)
 */
const isDevelopmentMode = (): boolean => {
	if (typeof window === 'undefined') return false;
	const hostname = window.location?.hostname;
	return hostname === 'localhost' || hostname === '127.0.0.1' || hostname?.startsWith('192.168.');
};

export const designerOptionsDefaults: DesignerOptionsData = {
	cursorMode: null,
	contextMenu: false,
	appliance: {
		showLabel: true,
		fontSizeFactor: 1
	},
	// url used to download component images
	assetsBaseUrl: '',
	assetsSasToken: '',
	// default auto zoom to disable
	useFractions: false,
	fps: {},
	// cutout opacity, appliance opacity = 100 - (this)
	backgroundColor: '#EDF2F7',
	applianceOpacity: 0,
	cutoutOpacity: 0,
	borderColor: 'darkgrey',
	cutoutColor: 'white',
	// Coordinate System
	// coordinateSystem: {
	// 	canvas: {
	// 		height: 480,
	// 		width: 480
	// 	},
	// 	viewport: {
	// 		xOffset: 0,
	// 		yOffset: 0
	// 	},
	// 	margin: {
	// 		top: 18,
	// 		bottom: 18,
	// 		left: 18,
	// 		right: 18
	// 	}
	// },
	dimensions: {
		fontSizeFactor: 1.25
	},
	// Corner
	corner: {
		show: true,
		thickness: CORNER_THICKNESS,
		width: 2.5
	},
	// -- panel placement from the bottom of the coordinate space
	panelBottomPadding: 9,
	// default designer to read-only
	readonly: false,
	highlightFrontPanel: false,
	// hide or show inside/outside dimensions of component
	showAllDimensions: false,
	showBreakpoints: true,
	showAppliances: true,
	showApplianceDimensions: true,
	showCutouts: true,
	showCountertops: true,
	showCorners: true,
	showControls: false,
	showDimensions: true,
	showDimensionsMode: null,
	showDisplayMode: false,
	showHints: true,
	showIslandBaseDimensions: true,
	showOverheadDimensions: true,
	showOverlap: true,
	showPanelInsideDimensions: false,
	showPanelOutsideDimensions: true,
	showTitle: true,
	showZoom: false,
	// Appliance Groups
	showApplianceGroups: false,
	showDeveloperInsights: false,
	debugCutouts: false,
	// 3D Rendering Quality (0-10: 0=wireframe, 1=fastest/lowest quality, 10=slowest/highest quality)
	renderQuality: 10,
	// Sky texture quality tier (0-10 | null). Defaults to 2 (lowest tier that still
	// loads a sky texture — ~1K "default" resolution) so initial load is fast and the
	// scene never auto-upgrades to a higher-res HDR. Users opt into higher tiers via
	// the Kitchen properties panel.
	// TODO: auto-detect a reasonable default from the user's machine specs
	// (GPU tier, device memory, connection speed) instead of hard-coding to 2.
	textureQuality: 2,
	// Debug visualization mode - defaults to true on localhost/development
	debugMode: isDevelopmentMode(),
	// Debug options (all default to true when debugMode is enabled)
	debugOptions: {
		cutouts: false, // Show semi-transparent red boxes where cutouts are applied
		lights: false, // Show light helper gizmos
		camera: false, // Show camera helper gizmos
		bounds: false, // Show bounding box visualizations
		showTools: true // Show the tools panel toggle button
	},
	// Blueprint transition mode when replacing one blueprint with another
	blueprintTransition: 'dissolve',
	// Default camera distance from scene center (feet) — used for empty scenes before a blueprint is loaded
	defaultCameraDistance: 30,
	autoZoomPadding: 0.95,
	autoZoomCameraHeightBoost: 0,
	autoZoomStyle: 'slide',
	// GPU preference: auto-detect GPU capabilities to set quality and power preference
	gpuPreference: 'auto',
	// Rotation arc visualizations are off by default — only the data-manager preview enables them
	showRotationArcs: false
};
